import { useFiatDisplay } from '@/hooks/useFiatDisplay';

import { popover } from '@/styles/popover';
import { fontStyles } from '@/styles/typography';

import { AlertCircleIcon } from '@/ui/Icons/AlertCircleIcon';
import {
  MatchaTooltip,
  MatchaTooltipContent,
  MatchaTooltipPopover,
  MatchaTooltipTrigger,
} from '@/ui/MatchaTooltip';

import { priceImpactTooltipContentBody, priceImpactTooltipContentHeader } from '@/utils/errors';
import { routes } from '@/utils/routes';

import { GenericOneLineAlert } from '../GenericOneLineAlert';

const tooltipTrigger = (
  <button className={popover().trigger()} data-testid="price-impact-alert-circle">
    <AlertCircleIcon className="justify-center" />
  </button>
);

const AlertTooltip = () => (
  <MatchaTooltip>
    <MatchaTooltipTrigger>{tooltipTrigger}</MatchaTooltipTrigger>
    <MatchaTooltipContent>
      <div>
        <h4 className={fontStyles({ variant: 'BODY_MD', class: 'text-token-gray-1600' })}>
          {priceImpactTooltipContentHeader}
        </h4>
        <p className="my-2 text-token-gray-800">{priceImpactTooltipContentBody}</p>
        <a
          href={`${routes.HELP_WHAT_IS_PRICE_IMPACT}`}
          className={fontStyles({ variant: 'LABEL_SM', class: 'text-token-purple-900' })}
          target="_blank"
          rel="noreferrer"
        >
          Learn more about price impact
        </a>
      </div>
    </MatchaTooltipContent>
    <MatchaTooltipPopover className="py-3" sideOffset={0} />
  </MatchaTooltip>
);

type PriceImpactAlertProps = {
  priceImpact: { percent: number; usd: number };
};

export const PriceImpactAlert = ({ priceImpact }: PriceImpactAlertProps) => {
  const { formatFiat } = useFiatDisplay();
  const { percent: priceImpactPercent, usd: priceImpactUsd } = priceImpact;
  return (
    <GenericOneLineAlert
      leftText={'Price Impact Warning'}
      leftComponent={<AlertTooltip />}
      rightText={`${priceImpactPercent.toFixed(2)}% (${formatFiat(priceImpactUsd)})`}
    />
  );
};
